import { CardContent, Typography } from "@mui/material";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { NumberInput, TextInput } from "react-admin";
import React from "react";

import { PlanningConfig } from "../types";

interface PlanningItemContentProps {
  config: PlanningConfig;
  currentActive: boolean;
  isSocManagement: boolean;
  isOverlappingDays: boolean;
  validateStartDate: (value: Date | null) => string | undefined;
  validateEndDate: (value: Date | null) => string | undefined;
  handleStartDateChange: (value: Date | null) => void;
  handleEndDateChange: (value: Date | null) => void;
  currentPlanningStartDate: Date;
  prevPlanningEndDate: Date | null;
}

const disabledEndDateStyles = {
  "& .MuiInputBase-input": {
    bgcolor: "rgba(0, 0, 0, 0.08)",
    color: "GrayText",
  },
};

const PlanningItemContent: React.FC<PlanningItemContentProps> = ({
  config,
  currentActive,
  isSocManagement,
  isOverlappingDays,
  validateStartDate,
  validateEndDate,
  handleStartDateChange,
  handleEndDateChange,
  currentPlanningStartDate,
  prevPlanningEndDate,
}) => {
  return (
    <CardContent
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 2,
      }}
    >
      <CustomDateTimeInput
        source={`${config.name}.start_date`}
        label="Start Date"
        onChange={handleStartDateChange}
        validate={validateStartDate}
        minDateTime={prevPlanningEndDate ?? new Date()}
        disabled={!currentActive}
      />
      <CustomDateTimeInput
        source={`${config.name}.end_date`}
        label="End Date"
        onChange={handleEndDateChange}
        validate={validateEndDate}
        minDateTime={currentPlanningStartDate}
        disabled={!currentActive}
        readOnly={!isSocManagement}
        sx={isSocManagement ? undefined : disabledEndDateStyles}
      />

      {isSocManagement ? (
        <NumberInput source={`${config.name}.targetSoc`} label="Target SOC" disabled={!currentActive} />
      ) : (
        <>
          <NumberInput
            source={`${config.name}.initial_soc_restoration_power`}
            label="Initial SOC Restoration Power"
            disabled={!currentActive}
          />
          <NumberInput source={`${config.name}.fcr_engagement`} label="FCR Engagement" disabled={!currentActive} />
          {config.chronicleFilename && (
            <TextInput source={`${config.name}.chronicleFilename`} label="Chronicle Filename" readOnly />
          )}
        </>
      )}

      <TextInput source={`${config.name}.mode`} label="Mode" readOnly />
      <NumberInput source={`${config.name}.reactivity_delay`} label="Reactivity delay" disabled={!currentActive} />

      {isOverlappingDays && (
        <Typography variant="caption" color="error">
          {"Attention : ce planning chevauche deux jours !"}
        </Typography>
      )}
    </CardContent>
  );
};

export default PlanningItemContent;
